import { type LocaleName } from '@solinkcorp/locale';

interface UpdateLocaleAction {
  type: 'UPDATE_LOCALE';
  localeCode: LocaleName;
}

export function updateLocale(localeCode: LocaleName): UpdateLocaleAction {
  return { type: 'UPDATE_LOCALE', localeCode };
}

export type LocaleReduxActions = UpdateLocaleAction;
